import listActions from 'src/modules/formCategory/list/formCategoryListActions';
import FormCategoryService from 'src/modules/formCategory/formCategoryService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'FORMCATEGORY_DESTROY';

const formCategoryDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: formCategoryDestroyActions.DESTROY_STARTED,
      });

      await FormCategoryService.destroyAll([id]);

      dispatch({
        type: formCategoryDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.formCategory.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/form-category');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: formCategoryDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: formCategoryDestroyActions.DESTROY_ALL_STARTED,
      });

      await FormCategoryService.destroyAll(ids);

      dispatch({
        type: formCategoryDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.formCategory.destroyAll.success'),
      );

      getHistory().push('/form-category');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: formCategoryDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default formCategoryDestroyActions;
